/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Benefits_Offer_ReviewInputs */

const en_directory_promotion_benefits_offer_review = /** @type {(inputs: Directory_Promotion_Benefits_Offer_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer review queue`)
};

const zh_directory_promotion_benefits_offer_review = /** @type {(inputs: Directory_Promotion_Benefits_Offer_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`优惠审核队列`)
};

/**
* | output |
* | --- |
* | "Offer review queue" |
*
* @param {Directory_Promotion_Benefits_Offer_ReviewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_benefits_offer_review = /** @type {((inputs?: Directory_Promotion_Benefits_Offer_ReviewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Benefits_Offer_ReviewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_benefits_offer_review(inputs)
	return zh_directory_promotion_benefits_offer_review(inputs)
});
export { directory_promotion_benefits_offer_review as "directory.promotion.benefits.offer_review" }